import { Box, styled, Container } from "@mui/material";
import { UnderConstruction } from "../components";

const PageWrapper = styled(Box)(() => ({
  paddingTop: "120px",
  minHeight: "60vh",
  display: "flex",
  flexDirection: "column",
  gap: "40px",
  paddingBottom: "80px",
  justifyContent: "center",
}));

export const ContactsPage = () => {
  return (
    <Container>
      <PageWrapper>
        <UnderConstruction>
          Мы работаем над разделом контактов. <br />
          Скоро здесь появятся все способы связи с нами.
        </UnderConstruction>
      </PageWrapper>
    </Container>
  );
};
